import { defineMessages } from 'react-intl';

export const paymentTerminalMessages = defineMessages({
    transaction_updated_success_title: {
      id: 'paymentTerminals.updated.success.title',
      defaultMessage: 'Success',
    },
    transaction_updated_success_message: {
      id: 'paymentTerminals.updated.success.message',
      defaultMessage: 'Payment terminal transaction updated successfully',
    },
    transaction_purchase_success_message: {
      id: 'paymentTerminals.purchase.success.message',
      defaultMessage: 'Payment terminal purchase transaction completed',
    },
    transaction_refund_success_message: {
      id: 'paymentTerminals.refund.success.message',
      defaultMessage: 'Payment terminal refund transaction completed',
    },
    transaction_pending_error_title: {
      id: 'paymentTerminals.pending.error.title',
      defaultMessage: 'Towing record has pending payment terminal transactions',
    },
    transaction_pending_error_message: {
      id: 'paymentTerminals.pending.error.message',
      defaultMessage: 'Check payment status from payment details section',
    },
    connect_button_label: {
      id: 'paymentTerminals.button.connect.label',
      defaultMessage: 'Connect to payment terminal',
    },
    refund_button_label: {
      id: 'paymentTerminals.button.refund.label',
      defaultMessage: 'Refund',
    },
    check_button_label: {
      id: 'paymentTerminals.button.check.label',
      defaultMessage: 'Check/fetch payment details',
    },
    refund_transaction_not_found_error: {
      id: 'paymentTerminals.error.refundTransactionNotFound',
      defaultMessage: 'No refundable payment transaction found, refresh the page and try again!',
    },
    terminal_not_found_error: {
      id: 'paymentTerminals.error.terminalNotFound',
      defaultMessage: 'The payment terminal linked to the payment transaction was not found!',
    },
    check_transaction_not_found_error: {
      id: 'paymentTerminals.error.checkTransactionNotFound',
      defaultMessage: 'No payment transaction to check was found, refresh the page and try again!',
    },
    connection_failed_error: {
      id: 'paymentTerminals.error.connectionFailed',
      defaultMessage: 'Failed to establish connection to the payment terminal!',
    },
    send_payment_data_failed_error: {
      id: 'paymentTerminals.error.sendPaymentDataFailed',
      defaultMessage: 'Failed to send payment details to the payment terminal!',
    },
    send_refund_failed_error: {
      id: 'paymentTerminals.error.sendRefundFailed',
      defaultMessage: 'Failed to send refund to the Innovoice server!',
    },
    purchase_failed_title: {
      id: 'paymentTerminals.purchase.failed.title',
      defaultMessage: 'Payment failed',
    },
    purchase_success_title: {
      id: 'paymentTerminals.purchase.success.title',
      defaultMessage: 'Payment successful',
    },
    refund_failed_title: {
      id: 'paymentTerminals.refund.failed.title',
      defaultMessage: 'Refund failed',
    },
    refund_success_title: {
      id: 'paymentTerminals.refund.success.title',
      defaultMessage: 'Refund successful',
    },
    check_transaction_invalid_error: {
      id: 'paymentTerminals.check.invalid.error',
      defaultMessage: 'Invalid payment terminal transaction!',
    },
    check_transaction_pending_message: {
      id: 'paymentTerminals.check.pending.message',
      defaultMessage:
        'Payment terminal transaction in progress, complete the payment on the terminal and fetch the details again',
    },
    check_transaction_success_message: {
      id: 'paymentTerminals.check.success.message',
      defaultMessage: 'Payment terminal charge successful ({referenceNumber})',
    },
    save_error_title: {
      id: 'paymentTerminals.save.error.title',
      defaultMessage: 'Error',
    },
    save_error_no_billing_rows_message: {
      id: 'paymentTerminals.save.error.noBillingRows',
      defaultMessage: 'The waybill has no payment rows.',
    },
    transaction_invalid_title: {
      id: 'paymentTerminals.transaction.invalid.title',
      defaultMessage: 'Payment terminal transaction invalid!',
    },
    transaction_success_title: {
      id: 'paymentTerminals.transaction.success.title',
      defaultMessage: 'Transaction successful!',
    },
    select_terminal_first_error: {
      id: 'paymentTerminals.error.selectTerminalFirst',
      defaultMessage: 'Select a payment terminal first!',
    },
    terminal_details_incomplete_error: {
      id: 'paymentTerminals.error.terminalDetailsIncomplete',
      defaultMessage: 'Payment terminal details incomplete!',
    },
    terminal_connected_label: {
      id: 'paymentTerminals.label.terminalConnected',
      defaultMessage: 'Payment terminal connected',
    },
    select_terminal_label: {
      id: 'paymentTerminals.label.selectTerminal',
      defaultMessage: 'Select payment terminal',
    },
    payment_terminals_label: {
      id: 'paymentTerminals.label.paymentTerminals',
      defaultMessage: 'Payment terminals',
    },
    send_receipt_label: {
      id: 'paymentTerminals.label.sendReceipt',
      defaultMessage: 'Send receipt {email}',
    },
    connected_terminal_description: {
      id: 'paymentTerminals.description.connectedTerminal',
      defaultMessage: 'Connected payment terminal:',
    },
    total_description: {
      id: 'paymentTerminals.description.total',
      defaultMessage: 'Total',
    },
    refund_success_message_title: {
      id: 'paymentTerminals.refund.success.messageTitle',
      defaultMessage: 'Payment terminal refund successful',
    },
    refund_button_full_label: {
      id: 'paymentTerminals.button.refundWithTerminal.label',
      defaultMessage: 'Refund with payment terminal',
    },
    refund_note_message: {
      id: 'paymentTerminals.refund.noteMessage',
      defaultMessage: 'the refund must be made using the same payment terminal that was used to charge the customer',
    },
    transaction_details_label: {
      id: 'paymentTerminals.label.transactionDetails',
      defaultMessage: 'Payment terminal transaction details',
    },
    unsaved_changes_message: {
      id: 'paymentTerminals.unsavedChanges.message',
      defaultMessage:
        'Changes made to the waybill must be saved before it can be connected to the payment terminal. Do you want to save the changes?',
    },
    unsaved_changes_close_label: {
      id: 'paymentTerminals.unsavedChanges.closeLabel',
      defaultMessage: 'Cancel',
    },
    unsaved_changes_confirm_label: {
      id: 'paymentTerminals.unsavedChanges.confirmLabel',
      defaultMessage: 'Save changes',
    },
  });